export default function getRandomizedArray(sum: number, length: number, maxDifferencePercent: number): number[] {
    if (maxDifferencePercent < 0 || maxDifferencePercent > 100) {
        throw new Error('maxDifferencePercent must be between 0 and 100');
    }
    if (sum <= 0 || length <= 0) {
        throw new Error('sum and length must be positive');
    }

    const average = sum / length;

    const randomArray: number[] = [];

    while (randomArray.length === 0 || randomArray[randomArray.length - 1] <= 0) {
        randomArray.length = 0;
        const min = average - (average * maxDifferencePercent) / 100;
        const max = average + (average * maxDifferencePercent) / 100;

        let currentSum = 0;
        for (let i = 0; i < length - 1; i++) {
            const randomValue = Math.random() * (max - min) + min;
            const roundedValue = Math.round(randomValue);

            randomArray.push(roundedValue);
            currentSum += roundedValue;
        }
        randomArray.push(sum - currentSum);
    }

    return randomArray;
}
